import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsBadgeModule,
    CmpsButtonModule,
    CmpsChipModule,
    CmpsDialogModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsPortalModule,
    CmpsRadioModule,
    CmpsSelectModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsDateRangeModule } from '../../../common/component/date-range';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { epicObs } from '../../../store';
import { ApiService } from '../core/api.service';
import { SocketService } from '../core/socket.service';
import { VirtualScrollComponent } from '../virtual-scroll/virtual-scroll.component';

import { CardCollectionComponent } from './component/card-collection/card-collection.component';
import { TranslationIdMap as CardCollectionTranslationIdMap } from './component/card-collection/card-collection.component.i18n';
import { CardActionsComponent } from './component/card/actions/card-actions.component';
import { CardComponent } from './component/card/card.component';
import { CardMessageComponent } from './component/card/message/card-message.component';
import { CardNameLabelComponent } from './component/card/name-label/card-name-label.component';
import { CardNameComponent } from './component/card/name/card-name.component';
import { CardStripeComponent } from './component/card/stripe/card-stripe.component';
import { CardTargetComponent } from './component/card/target/card-target.component';
import { CardTimestampComponent } from './component/card/timestamp/card-timestamp.component';
import { SearchFilterComponent } from './component/search-filter/search-filter.component';
import { TranslationIdMap as SearchFilterTranslationIdMap } from './component/search-filter/search-filter.component.i18n';
import { TabBarComponent } from './component/tab-bar/tab-bar.component';
import { EventCentreDialogComponent } from './event-centre-dialog.component';
import { eventCentreDialogEpics } from './event-centre-dialog.epic';
import { TranslationIdMap as DialogTranslationIdMap } from './event-centre-dialog.i18n';
import { EventCentreDialogService } from './event-centre-dialog.service';

@NgModule({
    declarations: [
        CardActionsComponent,
        CardCollectionComponent,
        CardComponent,
        CardMessageComponent,
        CardNameComponent,
        CardNameLabelComponent,
        CardStripeComponent,
        CardTargetComponent,
        CardTimestampComponent,
        EventCentreDialogComponent,
        SearchFilterComponent,
        TabBarComponent,
        VirtualScrollComponent,
    ],
    providers: [ApiService, EventCentreDialogService, SocketService],
    imports: [
        CmpsBadgeModule,
        CmpsButtonModule,
        CmpsChipModule,
        CmpsCommonModule,
        CmpsDateRangeModule,
        CmpsDialogModule,
        CmpsFilterModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(CardCollectionTranslationIdMap),
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsLazyI18nModule.forChild(SearchFilterTranslationIdMap),
        CmpsMenuModule,
        CmpsPortalModule,
        CmpsRadioModule,
        CmpsSelectModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CmpsEventCentreDialogModule {
    constructor() {
        eventCentreDialogEpics.forEach((e) => epicObs.next(e));
    }
}
